import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { constant, times } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringProp, values } from '@mews/fp';
import { toUtc } from '../../utils/dates';
import { getReservations } from '../entities/reservations/selectors';

interface PromotedServiceReservation {
    orderId: string;
    serviceId: string;
    startUtc: string;
    endUtc: string;
    reservationId: string;
}

export const getPromotedServiceReservations = createSelector(
    getReservations,
    getStringProp('timezone'),
    (reservations, timezone) =>
        pipe(
            reservations,
            values,
            array.filter(({ promotedServices }) => array.isNonEmpty(promotedServices)),
            array.map(({ promotedServices, orderId, startDate, endDate }) =>
                pipe(
                    promotedServices,
                    array.reduce(
                        [],
                        (acc: PromotedServiceReservation[], { id, count, reservationId, startUtc, endUtc }) => {
                            const promotedServiceReservation = {
                                orderId,
                                serviceId: id,
                                startUtc: startUtc ?? toUtc(startDate, timezone),
                                endUtc: endUtc ?? toUtc(endDate, timezone),
                                reservationId,
                            };
                            return [...acc, ...times(constant(promotedServiceReservation), count)];
                        }
                    )
                )
            ),
            array.flatten
        )
);
